import React from "react";

import { Paper } from "@/components/paper/Paper";

import { PromoCodeForm } from "./form/PromoCode.form";

export const PromoCodeModal: React.FC = () => {
  return (
    <Paper className="p-4 py-8 md:p-8 w-[400px] max-w-full min-h-min relative">
      <PromoCodeForm />
    </Paper>
  );
};
